if (document.querySelector(".media-and-text-carousal-list")) {
    var allSlides = document.querySelectorAll(".glide");
    var allSlidesArray = Array.prototype.slice.call(allSlides);

    allSlidesArray.forEach((slide) => {
        const glide = new Glide(slide, {
            type: "carousel",
            perView: 1,
            focusAt: 0,
            perTouch: 1,
            autoplay: false,
            accessibility: true,
            startAt: 0,
            rewind: true,
            draggable: true,
            swipeThreshold: 80,
            dragThreshold: 120,
            classes: {
                disabledArrow: "glide__arrow--disabled",
            },
            peek: {
                before: 0,
                after: 0,
            },
        });

        const totalSlides = slide.querySelectorAll('.glide__slide').length;
        const leftArrow = slide.querySelector('.glide__arrow--left');
        const rightArrow = slide.querySelector('.glide__arrow--right');

        if (totalSlides > 1) {
            glide.on('move.after', () => { // Update active bullet and arrow states after the slide transition
                document.querySelectorAll('.glide__bullet').forEach((bullet, index) => {
                    if (index === glide.index) {
                        bullet.classList.add('active');
                    } else {
                        bullet.classList.remove('active');
                    }
                });

                // Disable left arrow if on the first slide
                if (glide.index === 0) {
                    leftArrow.classList.add('glide__arrow--disabled');
                    leftArrow.setAttribute('aria-disabled', 'true');
                } else {
                    leftArrow.classList.remove('glide__arrow--disabled');
                    leftArrow.removeAttribute('aria-disabled');
                }

                // Disable right arrow if on the last slide
                if (glide.index === totalSlides - 1) {
                    rightArrow.classList.add('glide__arrow--disabled');
                    rightArrow.setAttribute('aria-disabled', 'true');
                } else {
                    rightArrow.classList.remove('glide__arrow--disabled');
                    rightArrow.removeAttribute('aria-disabled');
                }
            });

            glide.mount();

            // Initialize bullets and arrows visibility
            document.querySelectorAll('.glide__bullet').forEach((bullet, index) => {
                if (index === 0) {
                    bullet.classList.add('active');
                } else {
                    bullet.classList.remove('active');
                }
            });

            // Initialize arrow states
            leftArrow.classList.add('glide__arrow--disabled');
            leftArrow.setAttribute('aria-disabled', 'true');
        } else {
            const glide_controls_div = slide.querySelector('.glide__controls');
            if (glide_controls_div) {
                glide_controls_div.style.display = "none";
            }
        }
    });
}
